import { render, staticRenderFns } from "./LayerWidgetPanel.vue?vue&type=template&id=4d6bc63c&scoped=true"
import script from "./LayerWidgetPanel.vue?vue&type=script&lang=js"
export * from "./LayerWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./LayerWidgetPanel.vue?vue&type=style&index=0&id=4d6bc63c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6bc63c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6bc63c')) {
      api.createRecord('4d6bc63c', component.options)
    } else {
      api.reload('4d6bc63c', component.options)
    }
    module.hot.accept("./LayerWidgetPanel.vue?vue&type=template&id=4d6bc63c&scoped=true", function () {
      api.rerender('4d6bc63c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/LayerWidgetPanel.vue"
export default component.exports